module.exports = __webpack_public_path__ + "static/img/shl_news_center_videos_selected.09e0de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_news_center_videos_selected.png
// module id = b3pJ
// module chunks = 5